import { mediaQuery } from '../enums/mediaQuery';
import useMediaQuery from './useMediaQuery';

export const useMobile = () => {
  return useMediaQuery(mediaQuery.MOBILE);
};
